import React, { SVGProps } from 'react'
const SvgTransactionPushFailed = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#C11622"
      fillRule="evenodd"
      d="M1.875 10a8.125 8.125 0 1 1 16.25 0 8.125 8.125 0 0 1-16.25 0Zm15 0a6.875 6.875 0 1 0-13.75 0 6.875 6.875 0 0 0 13.75 0ZM10 5.217c.314 0 .574.23.618.532l.007.093v5.979a.625.625 0 0 1-1.243.092l-.007-.092V5.84c0-.345.28-.624.625-.624Zm0 8.326c.314 0 .574.232.618.533l.007.092v.353a.625.625 0 0 1-1.243.092l-.007-.092v-.353c0-.345.28-.625.625-.625Z"
      clipRule="evenodd"
      style={{
        fill: 'color(display-p3 .7569 .0863 .1333)',
        fillOpacity: 1,
      }}
    />
  </svg>
)
export default SvgTransactionPushFailed
